export default "__VITE_ASSET__cc69a10a__"